export const toastOptions = {
    isLoading: false,
    autoClose:5000,
    hideProgressBar:false,
    draggable: true,
    closeOnClick: true,
}